import React, { FC } from 'react';
import { Block, Spacing } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { StyledCheckCircleIcon, StyledDiv, StyledP, StyledT3 } from '../PersonalInformationsConfirmationPageContent.styles';
import { ContractChangeMessage } from '../../../../interfaces/ContractChangeMessage';

export interface ConfirmationSuccessSectionProps {
  changedContracts: ContractChangeMessage[];
}

const ConfirmationSuccessSection: FC<ConfirmationSuccessSectionProps> = ({ changedContracts }) => {
  const { t } = useTranslation('PersonalInformationsConfirmationPage');
  const noContracts = !changedContracts || changedContracts.length === 0;

  return (
    <Block white>
      <StyledDiv>
        <StyledCheckCircleIcon />
        <Spacing m-t={12}>
          <StyledT3>{noContracts ? t('successLabelNoContracts') : t('successLabel')}</StyledT3>
        </Spacing>
        {noContracts || changedContracts.map((x, i) => <StyledP strong key={i} data-testid={`success-${x.adjustedNumber}`}>{`${x.description} ${x.adjustedNumber}`}</StyledP>)}
      </StyledDiv>
    </Block>
  );
};
export default ConfirmationSuccessSection;
